import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import ResetPasswordModalDisplay from './ResetPasswordDisplay';
import AccountService from '../../Services/AccountService';

export default memo(ResetPasswordModalContainer);

const initState = {
  email: '',
  resetRequestPending: false,
};

const account = new AccountService();
function ResetPasswordModalContainer(props) {
  const [state, updateState] = useState(initState);
  const { toggleModal, showResetPasswordAlert } = props;

  const handleSubmit = async () => {
    updateState({ ...state, resetRequestPending: true });
    const { email } = state;
    try {
      const { message } = await account.forgotPassword({ email });
      toggleModal();
      showResetPasswordAlert('alert-confirmation', 'text-white', message);
    } catch (err) {
      toggleModal();
      showResetPasswordAlert(
        'danger',
        'text-white',
        'An error occurred, please try again later'
      );
    }
  };

  const handlePropUpdate = ({ target: { name, value } = {} }) => {
    updateState({ ...state, [name]: value });
  };

  return (
    <ResetPasswordModalDisplay
      {...props}
      {...state}
      handleSubmit={handleSubmit}
      handlePropUpdate={handlePropUpdate}
    />
  );
}

ResetPasswordModalContainer.propTypes = {
  toggleModal: PropTypes.func,
  showResetPasswordAlert: PropTypes.func,
};
